import DeploymentInfoForm from '../components/DeploymentInfoForm';
import Alert from '@mui/material/Alert';
import { useAppSelector } from '../../../../store/hooks';
import { selectDeploymentById } from '../../../../store/deployments/deploymentsSelector';

type Props = {
  readonly deploymentId: string;
  readonly hideDeploymentForm: () => void;
};

const DeploymentFormContainer = (props: Props) => {
  const { deploymentId, hideDeploymentForm } = props;

  const deployment = useAppSelector(state => selectDeploymentById(state, deploymentId));

  const failedServerReloads = deployment?.serverReloads
    .filter(serverReload => !serverReload.success) || [];

  const initialValues = {
    id: deployment?.id,
    serverId: deployment?.serverId,
    commitId: deployment?.commitId,
    status: deployment?.status,
    author: deployment?.author,
    createdDate: deployment?.createdDate,
    lastModifiedDate: deployment?.lastModifiedDate,
  };

  return (
    <>
      {!deployment ? (
        <Alert severity='error'>Error: Cannot open form due to deployment is not found!</Alert>
      ) : (
        <DeploymentInfoForm
          title='View deployment'
          deploymentId={deploymentId}
          failedServerReloads={failedServerReloads}
          initialValues={initialValues}
          onCancel={hideDeploymentForm}
          readOnly={true}
        />
      )}
    </>
  );
};

export default DeploymentFormContainer;
